<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="comments"/>
          {{ $t('emailHistory') }}
        </h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="tile">
          <div class="form-inline">
            <client-select :model="filterFormModel" class="mr-1 mb-1" attribute="client" @change="search" :isFilter="true" :place-holder="$t('selectClient') " ></client-select>
            <form-select :model="filterFormModel" attribute="direction" class="mr-1 mb-2" :options="[
              {text: this.$t('allEmails'), value: null},
              {text: this.$t('inboundEmail'), value: 1},
              {text: this.$t('outboundEmail'), value: 2},
            ]"></form-select>
            <form-select :model="filterFormModel" attribute="status" class="mr-1 mb-2" :options="[
               {text: this.$t('allStatuses'), value: null},
               {text: this.$t('success'), value: 'success'},
               {text: this.$t('failed'), value: 'failed'},
            ]"></form-select>
            <time-range-picker :model="filterFormModel" :label="$t('time')" class="mr-1 mb-2" :defaultShortcut="3"></time-range-picker>

            <button @click="load" class="btn btn-primary mr-1 mb-2">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-2">Reset</button>

            <history-export v-if="['owner','admin', 'tech' , 'operationsManager', 'account'].includes($store.state.user.role)" :filter="filterFormModel" :total-count="itemCount"/>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                            @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-lg-3">{{ $t('info') }}</div>
            <div class="col-lg-3">{{ $t('from') }}</div>
            <div class="col-lg-3">{{ $t('to') }}</div>
            <div class="col-lg-3">{{ $t('content') }}</div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-lg-3">
              <p><b>Domain: </b><span>{{ item.client.domain }}</span></p>
              <p>
                <b>{{ $t('createTime') }}:&nbsp;</b>
                <span>{{ item.createTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
              </p>
              <p v-if="item.sendTime">
                <b>{{ $t('sendTime') }}:&nbsp;</b>
                <span>{{ item.sendTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
              </p>
              <p v-if="item.openTime">
                <b>{{ $t('openTime') }}:&nbsp;</b>
                <span>{{ item.openTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
              </p>
              <p>
                <span class="badge badge-info mr-1" v-if="item.direction === 'inbound'">{{$t('inboundEmail')}}</span>
                <span class="badge badge-secondary mr-1" v-else>{{$t('outboundEmail')}}</span>
                <span class="badge badge-success" v-if="!item.sendError">{{$t('success')}}</span>
                <span class="badge badge-danger" v-else>{{$t('failed')}}</span>
              </p>
            </div>
            <div class="col-lg-3">
              <p v-if="item.fromEmail">
                <b>{{ $t('fromEmail') }}: </b><span>{{ item.fromEmail }}</span>
              </p>
              <p v-if="item.fromCustomer && item.direction === 'inbound'">
                <b>{{ $t('fromCustomer') }}: </b><span>{{ item.fromCustomer.name }}</span>
              </p>
              <p v-if="item.direction === 'outbound' && item.user">
                <b>{{ $t('fromUser') }}: </b><span>{{ item.user.name }}</span>
              </p>
          </div>
            <div class="col-lg-3">
              <p v-if="item.toEmail">
                <b>{{ $t('toEmail') }}: </b><span>{{ item.toEmail }}</span>
              </p>
              <p v-if="item.toUser">
                <b>{{ $t('toUser') }}: </b><span>{{ item.toUser.name }}</span>
              </p>
              <p v-if="item.toCustomer">
                <b>{{ $t('toCustomer') }}: </b><span>{{ item.toCustomer.name }}</span>
              </p>
            </div>
            <div class="col-lg-3">
              <p><b>{{ $t('emailType') }}: </b> {{ $t(`${item.type}Type`) }}</p>
              <p><b>{{ $t('emailSubject') }}: </b> {{ item.subject }}</p>
              <p v-if="item.sendErrorMsg && item.sendErrorMsg !== ''"><span class="text-gray-999 small">{{ $t('error')}}: </span> {{item.sendErrorMsg}}</p>
              <div>
                <button class="btn btn-info btn-sm" @click="showEmail(item)">
                  <i class="fa fa-info"></i>{{$t('detail')}}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="!items.length">{{ $t('notFoundSearch') }}</div>
      <div class="col-12" v-if="itemCount">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                      v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                      @input="load">
        </b-pagination>
      </div>
    </div>
    <b-modal size="xl" v-model="showForm" ok-only :title="$t('emailDetail')">
      <div><b>{{$t('emailType')}}</b>: {{$t(`${email.type}Type`)}}</div>
      <div class="row">
        <div class="col-md"><b>{{$t('fromEmail')}}</b>: {{email.fromEmail}}</div>
        <div class="col-md"><b>{{$t('toEmail')}}</b>: {{email.toEmail}}</div>
        <div class="col-md" v-if="email.ccEmail && email.ccEmail.length">
          <b>CC email</b>: {{email.ccEmail.join(", ")}}
        </div>
      </div>
      <div><b>{{$t('emailSubject')}}</b>: {{email.subject}}</div>
      <div><b>{{$t('content')}}: </b> <div class="alert border" v-html="email.content"></div></div>
    </b-modal>
  </main>
</template>

<script>
import list from '../../mixins/List';
import utils from '../../utils';
import ClientSelect from "@/components/ClientSelect";
import TimeRangePicker from "../../components/TimeRangePicker";
import _ from 'lodash';

export default {
  components: {TimeRangePicker, ClientSelect},
  mixins: [list, utils],
  data() {
    return {
      userRole: this.$store.state.user.role,
      service: '/email',
      autoLoad: true,
      showForm: false,
      email: {},
      defaultFilterFormModel: {
        client: null,
        brandName: null,
        direction: null,
        status: null
      }
    }
  },
  watch: {
    "filterFormModel.client": {
      handler(val) {
        this.oaFilter.client = val;
      }
    }
  },
  methods: {
    search: _.debounce(function () {
      this.filterFormModel.page = 1;
      this.load();
    }, 200),
    showEmail(email) {
      this.showForm = true;
      this.email = email;
    }
  },
  i18n: {
    messages: {
      en: {
        from: 'Gửi từ',
        to: 'Gửi tới',
        content: "Nội dung",
        fromEmail: "Gửi từ email",
        fromCustomer: "Gửi từ Khách hàng",
        toEmail: "Gửi tới email",
        toCustomer: "Gửi tới Khách hàng",
        createTime: 'Create time',
        sendTime: 'Send time',
        emailType: "Loại email",
        userType: "Email cá nhân",
        massType: "Email marketing",
        emailSubject: "Tiêu đề",
        emailDetail: "Chi tiết",
        emailHistory: "Lịch sử Email",
        allEmails: "Tất cả",
        inboundEmail: "Email gửi đến",
        outboundEmail: "Email gửi đi",
        fromUser: "Gửi từ nhân viên",
        toUser: "Gửi đến nhân viên",
        allStatuses: "Tất cả trạng thái",
        failed: "Thất bại",
      },
      vi: {
        from: 'Gửi từ',
        to: 'Gửi tới',
        content: "Nội dung",
        fromEmail: "Gửi từ email",
        fromCustomer: "Gửi từ Khách hàng",
        toEmail: "Gửi tới email",
        toCustomer: "Gửi tới Khách hàng",
        createTime: 'Tạo lúc',
        sendTime: 'Gửi lúc',
        emailType: "Loại email",
        userType: "Email cá nhân",
        massType: "Email marketing",
        emailSubject: "Tiêu đề",
        emailDetail: "Chi tiết",
        allEmails: "Tất cả",
        inboundEmail: "Email gửi đến",
        fromUser: "Gửi từ nhân viên",
        toUser: "Gửi đến nhân viên",
        allStatuses: "Tất cả trạng thái",
        failed: "Thất bại",
      }
    }
  }
}
</script>